import type { Attr } from 'App/babel/attributes/Attribute';
import { filterActiveAttributes } from 'App/babel/attributes/attributeHelpers';
import { getStandardFieldsEntity } from 'App/components/ListView/ListView';
import AppService from 'App/legacy/AppService';
import openModal from 'App/services/Modal';

type Options = {
	attributes: Record<string, Attr>;
	pickable: string[];
	columns: string[];
	tableType: string;
	onPick: (columns: string[]) => void;
};

export const openColumnPicker = ({ attributes, pickable, columns, tableType, onPick }: Options) => {
	const standardFields = AppService.getMetadata()?.standardFields[getStandardFieldsEntity(tableType)] ?? {};
	const active = filterActiveAttributes(
		Object.fromEntries(pickable.map(column => [column, attributes[column]])),
		standardFields
	);
	const selectables = Object.keys(active).map(key => ({
		key,
		field: active[key].field,
		title: active[key].title
	}));
	openModal('EditColumnsModal', {
		attributes,
		columns,
		selectables,
		tableType,
		onClose: picked => {
			if (picked) {
				onPick(picked);
			}
		}
	});
};
